export default "__VITE_ASSET__D$KE8jNd__"